function responseNavigation(collapse){

    $('#_navigation-dropdown .navigation__item').appendTo('#_navigation');
    var items = $('#_navigation').find('.navigation__item');
    var maxWidth = $('#_navigation').width() - $('#_navigation-dropdown').outerWidth();
    var width = 0;
    var hideFrom = 0;
    var screenWidth = $(window).width();

    items.each(function(index){
        if (width + $(this).outerWidth() > maxWidth){
            return false;
        }
        else {
            hideFrom = index;
            width += $(this).outerWidth();
        }
    });
    if (collapse) {
        $('#_navigation').removeClass('_flex');
        items.appendTo('#_navigation-dropdown__container');
        $('#_navigation-dropdown').show();
    }
    else if (hideFrom < items.length - 1) {
        items.eq(hideFrom).nextAll('.navigation__item').appendTo('#_navigation-dropdown__container');
        $('#_navigation-dropdown').show();
            if ( screenWidth <= 599 ) {
                items.appendTo('#_navigation-dropdown__container');
                $('#_navigation-dropdown').show();
            }
    }
    else {
        $('#_navigation-dropdown').hide();
    }

    $(document).on('mouseup touchend', function(e){
        if (!$('#_navigation-dropdown').is(e.target) && $('#_navigation-dropdown').has(e.target).length === 0) {
            $('#_navigation-dropdown').removeClass('_active');
            $('#_navigation-button').removeClass('_active');
        }
    });

}